import React from 'react'
import {
  CITIES_FOR_LANDING,
  PillarPage,
  SEARCH_PAGE_CITY_MAP,
  SearchPageCity
} from 'src/constants/searchPages'
import ga from 'src/utils/pixels/gtag'
import CityItem from './CityItem'

type ICitiesSectionProps = {
  closestCity: SearchPageCity | undefined
  pillar?: PillarPage
}

/** Closest city first (when it isn't already curated), then the curated
 *  landing cities. Shared with the home rail's `CityLinks` strip. */
export const getLandingCities = (closestCity: SearchPageCity | undefined) => {
  const citySlugs = [
    ...(closestCity &&
    !CITIES_FOR_LANDING.includes(closestCity) &&
    SEARCH_PAGE_CITY_MAP[closestCity]?.cityName
      ? [closestCity]
      : []),
    ...CITIES_FOR_LANDING.filter((c) => c !== SearchPageCity.Base)
  ]
  return citySlugs
    .filter((city) => SEARCH_PAGE_CITY_MAP[city]?.cityName)
    .map((city) => ({ city, cityMap: SEARCH_PAGE_CITY_MAP[city] }))
}

function CitiesSection({ closestCity, pillar }: ICitiesSectionProps) {
  const pillarSlug = pillar ?? PillarPage.SelfStorage
  const cities = getLandingCities(closestCity)

  return (
    <div className="flex flex-wrap items-center gap-2">
      {cities.map(({ city, cityMap }, index) => (
        <CityItem
          key={city}
          name={cityMap.cityName}
          link={`/${pillarSlug}/${city}`}
          closest={city === closestCity}
          lastCity={index >= cities.length - 3}
          onTileClick={() =>
            ga.event('home_city_tile_click', {
              city,
              pillar: pillarSlug,
              is_closest: city === closestCity
            })
          }
        />
      ))}
    </div>
  )
}

export default React.memo(CitiesSection)
